export default __webpack_public_path__ + "static/plorbus-54a42b7cb3233f41f3d9fddb5c5fb80b.png";